import { GameMode } from '../types';

type AccentConfig = {
  name: GameMode;
  accent: string;
  secondary: string;
  divider: string;
};

const ACCENTS: Record<GameMode, AccentConfig> = {
  daily: { name: 'daily', accent: '#4DF4FF', secondary: '#A27BFF', divider: '#4DF4FF' },
  random: { name: 'random', accent: '#FF4CF0', secondary: '#4DF4FF', divider: '#FF4CF0' },
  'top-100': { name: 'top-100', accent: '#FF8FB1', secondary: '#D4FF4F', divider: '#FF8FB1' },
  africa: { name: 'africa', accent: '#D4FF4F', secondary: '#4DF4FF', divider: '#D4FF4F' },
  asia: { name: 'asia', accent: '#FF4CF0', secondary: '#D4FF4F', divider: '#FF4CF0' },
  europe: { name: 'europe', accent: '#4DF4FF', secondary: '#A27BFF', divider: '#A27BFF' },
  'north-america': { name: 'north-america', accent: '#A27BFF', secondary: '#4DF4FF', divider: '#A27BFF' },
  'south-america': { name: 'south-america', accent: '#FF8FB1', secondary: '#FF4CF0', divider: '#FF8FB1' },
  india: { name: 'india', accent: '#4DF4FF', secondary: '#FF8FB1', divider: '#4DF4FF' },
  china: { name: 'china', accent: '#FF4CF0', secondary: '#A27BFF', divider: '#FF4CF0' },
  'asia-ex-india-china': { name: 'asia-ex-india-china', accent: '#4DF4FF', secondary: '#D4FF4F', divider: '#4DF4FF' },
};

export function getAccentByMode(mode: GameMode): AccentConfig {
  return ACCENTS[mode];
}

export function applyTheme(theme: 'light' | 'dark') {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.backgroundColor = theme === 'light' ? '#101429' : '#040414';
}
